// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "p[data-v-06d7c2cc]{color:grey;font-size:1em}h5[data-v-06d7c2cc]{font-size:1.5em}", ""]);
// Exports
module.exports = exports;
